import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import TranslateIcon from '@mui/icons-material/Translate';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import MicIcon from '@mui/icons-material/Mic';

import CropFreeIcon from '@mui/icons-material/CropFree';
import LayersIcon from '@mui/icons-material/Layers';
import AddchartIcon from '@mui/icons-material/Addchart';

import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import TextIncreaseIcon from '@mui/icons-material/TextIncrease';

export const editorLangDeStrs = {
    
    /** Updated at 01.12.2025 */
    
    //Hero component
    chip_label: "Neu: Leistungsstarke AI-Videobearbeitungssuite",
    main_headline_part_1: "Dein All-in-One ",
    main_headline_part_2: "Cloud-Video-",
    main_headline_part_3: "Workspace.",
    main_headline_part_4: "Bearbeite alles. Überall.",
    main_subtitles: "Fortschrittliche AI-Videoerstellung im Browser: Konvertiere horizontal zu vertikal, schneide Szenen automatisch, verfolge Gesichter und bewahre die Sprecheridentität mit Next-Gen AI-Synchronisation.",
    feature_cards: [
        {
            icon: <AutoAwesomeIcon fontSize="large" sx={{ color: '#00BCD4' }}/>,
            title: "AI-Viral-Generator",
            description: "Erstelle in Sekunden virale Shorts mit Gesichtsverfolgung aus langen Videos."
          },
          {
            icon: <MicIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
            title: "Voice-Cloning & Dubbing",
            description: "Synchronisiere in 40+ Sprachen unter Beibehaltung der originalen Stimmidentität."
          },
          {
            icon: <TranslateIcon fontSize="large" sx={{ color: '#2196F3' }}/>,
            title: "Auto-Subs & Übersetzung",
            description: "99% genaue Untertitel und Sofortübersetzung."
          },
          {
            icon: <AddAPhotoIcon fontSize="large" sx={{ color: '#E91E63' }}/>,
            title: "Generative AI-Suite",
            description: "Integrierte Text-to-Speech- & AI-Bildgenerierung."
          }
    ],
    start_editing_button: "Jetzt bearbeiten →",
    ai_dubbing_button: "AI-Synchronisation testen (Beta)",
    workspace_preview: "Video-Workspace-Vorschau",
    //Discover
    discover_ai_shorts_features: [
        {
          icon: <CropFreeIcon fontSize="large" sx={{ color: '#00BCD4' }}/>,
          title: "AI-Gesichtsverfolgung",
          description: "Intelligentes Reframing hält den Sprecher im 9:16-Hochformat perfekt zentriert."
        },
        {
          icon: <LayersIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
          title: "Batch-Generierung",
          description: "Lade ein 60-Minuten-Video hoch und erhalte sofort 40+ fertig geschnittene, untertitelte Shorts."
        },
        {
          icon: <AddchartIcon fontSize="large" sx={{ color: '#2196F3' }} />,
          title: "Viralitäts-Score",
          description: "Unsere AI bewertet Clips nach potenziellem Engagement, damit du nur das Beste postest."
        }
    ],
    discory_label: "⚡ DER CONTENT-MULTIPLIKATOR",
    discovery_left_headline_1: "Ein Querformat-Video.",
    discovery_left_headline_2: "40+ Virale Shorts.",
    disocry_left_headline_3: "Lass deinen Podcast- oder YouTube-Content nicht verstauben. Kedy.ai identifiziert automatisch virale Hooks, setzt den aktiven Sprecher neu ins Bild und generiert in Minuten ansprechende vertikale Clips.",
    discovery_CTA_button: "Verwandle jetzt 1 Video in 10 Shorts →",
    discovery_video_mockups_1: "ORIGINALSERIE",
    discovery_video_mockups_2: "Die Tech-Revolution",
    discovery_video_mockups_3: "S4 • F2",
    discovery_video_mockups_4: "DAS IST WAHNSINN! 🤯",

    // Other tools
    other_tools_features: [
        {
          icon: <MicIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
          title: "Echtes Voice-Cloning",
          description: "Wir analysieren deinen einzigartigen Stimmabdruck, um eine synchronisierte Version zu erstellen, die genau wie du klingt."
        },
        {
          icon: <ChatBubbleIcon fontSize="large" sx={{ color: '#E91E63' }}/>,
          title: "Perfekte Lippensynchronisation (Beta)",
          description: "Das Video wird subtil an die Lippenbewegungen der neuen Sprache angepasst, für einen natürlichen Look."
        },
        {
          icon: <TextIncreaseIcon fontSize="large" sx={{ color: '#2196F3' }}/>,
          title: "Kontextuelle Übersetzung",
          description: "Slang, Redewendungen und Fachbegriffe werden akkurat übersetzt, um die ursprüngliche Bedeutung zu wahren."
        }
    ],

    other_tools_right_side_label:"🎙️ GLOBALES VOICE-STUDIO",
    other_tools_headline:"Werde Global.",
    speak_local:"Sprich Lokal.",
    ai_dubbing_explanation: "Überwinde Sprachbarrieren, ohne deine Identität zu verlieren. Unsere AI-Synchronisation übersetzt deinen Content in 40+ Sprachen und bewahrt dabei deine originale Stimme, Emotion und Intonation.",
    other_tools_CTA_button: "Meine Stimme klonen & synchronisieren",
    global_reach_badge_1: "Voice-Cloning",
    global_reach_badge_2: "98% Übereinstimmung",
    global_reach_badge_3: "Globale Reichweite",
    global_reach_badge_4: "40+ Sprachen unterstützt",

    // Social
    social_left_menu_badge: "NAHTLOSE INTEGRATION",
    social_left_menu_title_1: "Verbinde dein gesamtes",
    social_left_menu_title_2: "kreatives Ökosystem.",
    social_left_menu_explanation: "Verschwende keine Zeit mit Herunterladen und erneutem Hochladen. Kedy.ai verbindet sich direkt mit deinen Lieblingsplattformen für One-Click-Publishing und Asset-Synchronisation.",
    social_features: [
      {
        title: "Intelligente Planung",
        desc: "Plane im Voraus. Wähle spezifische Daten und Uhrzeiten für die Veröffentlichung deiner Inhalte.",
        color: '#22d3ee'
      },
      {
        title: "Direkter Video-Upload",
        desc: "Lade 4K-Material direkt von deinem Gerät in den Cloud-Editor hoch.",
        color: '#a78bfa'
      },
      {
        title: "Sichere API-Verwaltung",
        desc: "Verschlüsselung auf Unternehmensniveau für alle deine verbundenen Konten.",
        color: '#34d399'
      }
    ],
    social_right_menu_title: "API-Schlüssel & Verbindungen",

    // Carousel
    loved_by_creators_1: "Geliebt von",
    loved_by_creators_2: "Kreativen",
    loved_by_creators_3: "Automatisierte Workflows für die Besten der Branche.",
    carousel_button_1: "Kostenlos starten",
    carousel_button_2: "Demo buchen",

    /** Updated at 01.12.2025 */

    welcomNewProject: 'Willkommen bei Ihrem neuen Projekt',
    pls_add_media: 'Bitte fügen Sie Medien zu Ihrem Projekt hinzu',
    add_video: 'Video hinzufügen',
    add_audio: 'Audio hinzufügen',
    add_image: 'Bild hinzufügen',
    add_webcam: 'Webcam-Aufnahme',
    add_screen: 'Bildschirmaufnahme',
    add_webcam_screen: 'Webcam & Bildschirmaufnahme',
    capture_screen_camera: 'Erfassen Sie Ihren Bildschirm & Kamera!',
    video_captureDevice: 'Videofanggerät',
    resolution: 'Auflösung',
    audio_captureDevice: 'Audiofanggerät',
    resize_video: 'Videogröße ändern',
    rotate_video: 'Video drehen',
    loop_video: 'Video schleifen',
    joinmarge_video: 'Video hinzufügen/zusammenführen',
    cut_video: 'Video schneiden',
    crop_video: 'Video zuschneiden',
    translate_video: 'Video übersetzen',
    transcripbe_video: 'Video transkribieren',
    auto_subtitles: 'Automatische Untertitel',
    add_subtitle_video: 'Untertitel zum Video hinzufügen',
    compress_video: 'Video komprimieren',
    convert_video: 'Video konvertieren',
    project_not_accessible: 'Projekt ist nicht zugänglich',
    continue: 'Fortfahren',
    leave: 'Verlassen',
    cancel: 'Abbrechen',
    submit: 'Einreichen',
    okay: 'OK',
    stop: 'Stoppen',
    record: 'Aufnehmen',
    ongoing_upload_project_str: 'Es läuft gerade ein Upload zu diesem Projekt.',
    leaving_page_sure: 'Sie verlassen diese Seite, sind Sie sicher?',
    uploading_files: 'Dateien hochladen',
    record_screen_and_upload: 'Nehmen Sie Ihren Bildschirm auf und laden Sie hoch.',
    show_defaul_sharingMenu: 'Standardfreigabemenü anzeigen',
    prefer_share_browser: 'Bevorzugen, einen Browser-Tab zu teilen',
    prefer_share_window: 'Bevorzugen, ein Fenster zu teilen',
    prefer_share_entireScreen: 'Bevorzugen, den ganzen Bildschirm zu teilen',
    record_webcam_and_upload: 'Nehmen Sie Ihre Webcam auf und laden Sie hoch.',
    sign_signup_to_uploadVideos: 'Bitte melden Sie sich an oder registrieren Sie sich, um Videos hochzuladen',
    sizelimir_or_timelimit: 'größer als 250 MB oder länger als 5 Minuten',
    screen_capture_preferences: 'Bildschirmaufnahme-Einstellungen',
    is_uploading: 'Wird hochgeladen',
    monthly: 'Monatlich',
    annually: 'Jährlich',
    most_popular: 'Am beliebtesten',
    export: 'Exportieren',
    bitrate: 'Bitrate',
    frame_rate_fps: 'Bildrate (FPS)',
    produce: 'Produzieren',
    setup: 'Einrichten',
    template: 'Vorlage',
    templates: 'Vorlagen',
    media: 'Medien',
    stock: 'Lager',
    translations: 'Übersetzungen',
    subtitles: 'Untertitel',
    text_to_speech: 'Text zu Sprache',
    transitions: 'Übergänge',
    text: 'Text',
    emojis: 'Emojis',
    filters: 'Filter',
    draw: 'Zeichnen',
    edit_subtitle: 'Untertitel bearbeiten',
    add_new_subtitle: 'neuen Untertitel hinzufügen',
    select_brush_stock_start_draw: 'Wählen Sie einen Pinselstrich, um mit dem Zeichnen zu beginnen',
    brush_stroke: 'Pinselstrich',
    round: 'Rund',
    sliced: 'Geschnitten',
    color: 'Farbe',
    opacity: 'Deckkraft',
    size: 'Größe',
    duration: 'Dauer',
    add_new_line: 'Neue Zeile hinzufügen',
    all_types: 'Alle Typen',
    load_more: 'Mehr laden',
    upload_video: 'Video hochladen',
    upload_audio: 'Audio hochladen',
    upload_image: 'Bild hochladen',
    create_webcam_recording: 'Webcam-Aufnahme erstellen',
    create_screen_capture_recording: 'Bildschirmaufnahme erstellen',
    create_webcam_screen_recording: 'Webcam & Bildschirmaufnahme erstellen',
    project_asset: 'Projektvermögen',
    you_want_add_translations: 'Wie möchten Sie Übersetzungen hinzufügen?',
    uploader: 'Uploader',
    auto: 'AUTO',
    auto_translations: 'Automatische Übersetzungen',
    automatically_add_transllations_video: 'Automatisch Übersetzungen zum Video hinzufügen',
    wait_moments_subtitles_being: 'Warten Sie einen Moment, während der Untertitel vorbereitet wird',
    select_language_detect: 'Sprache zur Erkennung auswählen',
    select_different_target_language: 'Wählen Sie eine andere Zielsprache',
    select_different_source_and_target_languages: 'Quell- und Zielsprachen können nicht gleich sein',
    voice_clones: "Sprachklone",
    source_language: "Quellsprache",
    select_source_language: "Wählen Sie Ausgangssprache",
    select_target_language: 'Zielsprache auswählen',
    redub_another_language: 'Mit einer anderen Sprache erneut synchronisieren',
    upload_new_file: 'Neue Datei Hochladen',
    no_title: 'Kein Titel', 
    unknown: 'Unbekannt',
    watch_video: 'Video ansehen',
    listen_audio: 'Audio anhören',
    video_preparing: 'Video wird vorbereitet',
    audio_preparing: 'Audio wird vorbereitet',
    delete_voice_clone: 'Stimmklon löschen',
    delete_voice_clone_assets: 'Stimmklon mit Assets löschen',
    no_voice_clones: 'Keine Stimmklone zum Anzeigen',  
    upload_file_to_create_first_voice_clone: 'Lade eine Datei hoch, um deinen ersten Stimmklon zu erstellen und die Sprachbarriere zu überwinden',
    disable_translate: 'Übersetzen deaktivieren',
    select_language_select: 'Sprache zum Übersetzen auswählen',
    transition_duration: 'Übergangsdauer',
    coming_soon: 'Demnächst',
    language: 'Sprache',
    english: "Englisch",
    spanish: "Spanisch",
    french: "Französisch",
    german: "Deutsch",
    italian: "Italienisch",
    portuguese: "Portugiesisch",
    polish: "Polnisch",
    turkish: "Türkisch",
    russian: "Russisch",
    dutch: "Niederländisch",
    czech: "Tschechisch",
    arabic: "Arabisch",
    chinese: "Chinesisch",
    hungarian: "Ungarisch",
    korean: "Koreanisch",
    japanese: "Japanisch",
    hindi: "Hindi",
    danish: "Dänisch",
    greek: "Griechisch",
    finnish: "Finnisch",
    hebrew: "Hebräisch",
    malay: "Malaiisch",
    norwegian: "Norwegisch",
    swedish: "Schwedisch",
    swahili: "Suaheli",
    speaking_rate_defaul: 'Sprechgeschwindigkeit (Standard 1)',
    pitch_defaul: 'Tonhöhe (Standard 0)',
    volume_gain_default: 'Lautstärkeerhöhung (Standard 0)',
    create_text_speech: 'Text zu Sprache erstellen',
    add_text: 'Text hinzufügen',
    text: 'Text',
    start: 'Start',
    end: 'Ende',
    text_style: 'Textstil',
    background_color: 'Hintergrundfarbe',
    add_new_text_field: 'Neues Textfeld hinzufügen',
    how_add_subtitles: 'Wie möchten Sie Untertitel hinzufügen',
    automatically_subtitles_video: 'Automatisch Untertitel zum Video hinzufügen',
    text_color: 'Textfarbe',
    preview_text: 'Textvorschau',
    search: 'Suchen',
    orientation: 'Orientierung',
    next: 'Weiter',
    previous: 'Vorherige',
    first: "Erste",  
    last: "Letzte",
    locale: 'Standort',
    landscape: 'Querformat',
    portrait: 'Hochformat',
    square: 'Quadratisch',
    time: 'Zeit',
    background: 'Hintergrund',
    project_setting: 'Projekteinstellungen',
    use_template_project: 'Als Vorlageprojekt verwenden',
    visibility: 'Sichtbarkeit',
    category: 'Kategorie',
    capture_thumbnail: 'Miniaturansicht erfassen',
    brand_kit: 'Marken-Kit',
    video_placeholder: 'Video-Platzhalter2.mp4',
    replace_video: 'Video ersetzen',
    transformations: 'Transformationen',
    fill_canvas: 'Die Leinwand füllen',
    fit_canvas: 'Auf die Leinwand anpassen',
    round_corners: 'Abgerundete Ecken',
    audio: 'Audio',
    detach_audio: 'Audio trennen',
    cleanAudio: 'CleanAudio',
    upgrade_basic_unlock: 'Auf BASIC upgraden, um freizuschalten',
    remove_background_noise_enhance_audio_qty: 'Hintergrundgeräusche entfernen und Audioqualität verbessern',
    color_correction: 'Farbkorrektur',
    reset: 'Zurücksetzen',
    exposure: 'Belichtung',
    brightness: 'Helligkeit',
    contract: 'Kontrast',
    saturation: 'Sättigung',
    sharpen: 'Schärfen',
    blur: 'Weichzeichnen',
    noise: 'Rauschen',
    trending: 'TRENDING',
    custom: 'BENUTZERDEFINIERT',
    portrait: 'HOCHFORMAT',
    landscape: 'QUERFORMAT',
    settings: 'Einstellungen',
    magic_draw: 'Magisches Zeichnen',
    tools: 'Werkzeuge',
    brush_size: 'Pinselgröße',
    save: 'Speichern',
    clear: 'Löschen',
    view_all: 'Alle anzeigen',
    save_your_project_later: 'Speichern Sie Ihr Projekt für später',
    sign_in: 'anmelden',
    sign_up: 'registrieren',
    sign_up_home: 'Registrieren',
    redo: 'Wiederholen',
    undo: 'Rückgängig machen',
    collaborate: 'Kooperieren',
    enter_email_share_project: 'E-Mail eingeben, um Projekt zu teilen',
    share_project: 'Projekt teilen',
    create_new_workspace: 'Neuen Arbeitsbereich erstellen',
    audio_noise_remove: 'Entfernung von Audiorauschen',
    media_upload: 'Medien-Upload',
    draw_color: 'Farbe zeichnen',
    tsl_none: 'keiner',
    tsl_fade: 'Verblassen',
    tsl_book_flip: 'Buch-Flip',
    tsl_disolve: 'Sich auflösen',
    tsl_doorway: 'Tür',
    tsl_blur: 'Verwischen',
    tsl_push: 'Drücken',
    tsl_slide: 'Gleiten',
    tsl_wipe: 'Wischen',
    tsl_zoom_in: 'Hineinzoomen',
    tsl_zoom_out: 'Rauszoomen',
    flt_None: 'Keiner',
    flt_Darker: 'Dunkler',
    flt_BlacknWhite: 'Schwarz und Weiß',
    flt_Daphne: 'Seidelbast',
    flt_Penelope: 'Penelope',
    flt_Phoebe: 'Phoebe',
    flt_Thalia: 'Thalia',
    flt_Chloe: 'Chloe',
    flt_Hermione: 'Hermine',
    flt_Hera: 'Hera',
    flt_Rhea: 'Rhea',
    flt_Donna: 'Donna',
    flt_Martina: 'Martina',
    flt_Gabriella: 'Gabriella',
    flt_Elisabetta: 'Elisabetta',
    flt_Isabella: 'Isabella',
    flt_Luna: 'Luna',
    flt_Viola: 'Viola',
    flt_Zita: 'Zita',
    flt_Donata: 'Donata',
    flt_Maddalena: 'Maddalena',
    flt_Tecla: 'Tecla',
    flt_Narcisa: 'Narcisa',
    emj_Smileys: 'Smileys',
    emj_Animals: 'Tiere',
    emj_People: 'Menschen',
    emj_Jobs: 'Arbeitsplätze',
    emj_Sports: 'Sport',
    emj_Flags: 'Flaggen',
    emj_Signs: 'Zeichen',
    emj_Nature: 'Natur',
    emj_Travel: 'Reisen',
    emj_Letters: 'Briefe',
    emj_Misc: 'Sonstiges',
    create_empty_project_templates: 'Erstellen Sie ein leeres Projekt aus Vorlagen',
    days_ago: 'vor Tagen', 
    hours_ago: 'vor Stunden',
    minutes_ago: 'vor Minuten',
    seconds_ago: 'vor Sekunden',
    create_workspace: 'Arbeitsbereich erstellen',
    workspace: 'Arbeitsbereiche',
    delete_workspace: 'Arbeitsbereich löschen',
    transfer_owner: 'Eigentümer übertragen',
    can_create_new_workspace: 'Könnten Sie einen neuen Arbeitsbereich erstellen?',
    could_delete_workspace: 'Könnten Sie den Arbeitsbereich löschen?',
    available_subtitles_time: 'Verfügbare Untertitelzeit',
    available_storage_space: 'Verfügbarer Speicherplatz',
    available_text_to_speech: 'Verfügbare Text-zu-Sprache',
    other_workspaces: 'Andere Arbeitsbereiche',
    members: 'Mitglieder',
    add_member: 'Mitglied hinzufügen',
    remove_member: 'Mitglied entfernen',
    change_member_level: 'Mitgliedsebene ändern',
    owner: 'Eigentümer',
    admin: 'Administratorin',
    member: 'Member',
    read_only: 'Schreibgeschützt',
    invitation_list: 'Einladungsliste',
    duplicate: 'Duplikat',
    splite: 'Teilt',
    remove: 'entfernen',
    layer: 'Schicht',
    volume: 'Volumen',
    deleterow: 'Zeile löschen',
    fullscreen: 'Ganzer Bildschirm',
    editsubtitle: 'Untertitel bearbeiten',
    fit: 'Fit',
    green_screen: 'Grüner Bildschirm',
    profile: 'Profil',
    contact_us: 'Kontaktieren',
    pricing: 'Preisgestaltung',
    login: 'Anmeldung',
    logout: 'Ausloggen',
    get_started_free: "Legen Sie los–es ist kostenlos",
    dashboard: 'Armaturenbrett',
    projects: 'Projekte',
    menu_Features: 'Merkmale',
    menu_Tools: 'Werkzeuge',
    menu_VideoEditor: 'Videobearbeiter',
    menu_AIVideoEditor: 'KI-Videobearbeiter',
    menu_AddImgToVideo: 'Bild zum Video hinzufügen',
    menu_AddMusicToVideo: 'Musik zum Video hinzufügen',
    menu_AddTextToVideo: 'Text zum Video hinzufügen',
    menu_FilterVideo: 'Video filtern',
    menu_AddTransitionstoVideo: 'Übergänge zum Video hinzufügen',
    menu_AddFreeStockVideos:'Fügen Sie kostenlose Stockvideos hinzu',
    menu_SubtitlesTranscription: 'Untertitel und Transkription',
    menu_AddSubtitlesToVideo: 'Untertitel zum Video hinzufügen',
    menu_AudioToText: 'Audio zu Text',
    menu_AutoSubtitles: 'Automatische Untertitel',
    menu_TranscribeVideo: 'Video transkribieren',
    menu_TranslateVideo: 'Video übersetzen',
    menu_Toolkit: 'Toolkit',
    menu_Crop: 'Ernte',
    menu_Cut: 'Schneiden',
    menu_JoinMerge: 'Beitreten / Zusammenführen',
    menu_LoopVideo: 'Loop-Video',
    menu_Resize: 'Größe ändern',
    menu_Rotate: 'Drehen',
    menu_More: 'Mehr',
    menu_VideoCompressor: 'Videokompressor',
    menu_VideoConverter: 'Videokonverter',
    menu_AIGenerated: 'KI-generiert',
    menu_AIGeneratedImages: 'KI-generierte Bilder',
    menu_AIGeneratedVideos: 'KI-generierte Videos',
    menu_AIGeneratedVoices: 'KI-generierte Stimmen',
    menu_Blog: 'Blog',
    menu_VIDEOOBlog: 'Kedy.AI Blog',
    menu_VIDEOOHowTo: 'Kedy.AI Anleitung',
    menu_VIDEOOCareers: 'Kedy.AI-Karriere',
    try_autosubtitles_in_english: 'Probieren Sie automatische Untertitel in Englisch',
    try_translations_in_turkish: 'Probieren Sie Übersetzungen in German',
    try_subtitles_in_spanish: 'Probieren Sie Untertitel in Spanisch',
    try_ai_video_summary: 'Probieren Sie die KI-Videozusammenfassung',
    online_ai_video_editor : 'Online-KI-Videobearbeiter',
    online_could_video_editor: 'Online-Cloud-basierter Video-Editor',
    home_free_trial_detail: '7 Tage kostenlos testen, jederzeit kündbar',
    home_create_button_detail: 'Videoerstellung mit einem Klick mit automatisierten Untertiteln, Übersetzung und mehr',
    create_now: 'Jetzt erstellen',
    home_templates_start: 'Entdecken Sie eine Reihe von Vorlagen, um loszulegen',
    try_now_required: 'Probieren Sie es jetzt aus, kein Konto erforderlich',
    online_collaborative_video_editing: 'Kollaborative Online-Videobearbeitung',
    online_collaborative_video_editing_detail: 'Tauchen Sie mit kedy.ai in die Welt der cloudbasierten Online-Videobearbeitung ein. Unsere Plattform revolutioniert die Art und Weise, wie Sie bearbeiten, und bietet Online-Funktionen zur kollaborativen Videobearbeitung und einen cloudbasierten Arbeitsbereich für die Videobearbeitung.',
    auto_subtitles_translations: 'Automatische Untertitel und Übersetzungen',
    auto_subtitles_translations_detail: "Verbessern Sie Ihre Videos mit unserer Funktion „Automatische Untertitel und Übersetzungen“, einem Teil unserer professionellen Online-Videobearbeitungssoftware. kedy.ai wurde als Videobearbeitungssoftware für jedermann konzipiert und macht es einfach, Inhalte zu erstellen, die zugänglich und eingängig sind.",
    ai_base_text_speech: 'KI-basierter Text-to-Speech',
    ai_base_text_speech_detail: 'Unsere KI-basierten Text-to-Speech-Stimmen eignen sich perfekt für Content-Ersteller und verkörpern das Konzept der Videobearbeitung neu erfunden für Youtuber und Influencer. Mit kedy.ai verwandeln Sie Ihre Skripte in ansprechende Voiceovers, verleihen Ihren Videos eine professionelle Note und optimieren Ihren Produktionsprozess.',
    free_user_stock_video: 'Kostenlose Nutzung von Stockvideos',
    free_user_stock_video_detail: 'Greifen Sie mit kedy.ai auf eine umfangreiche Sammlung kostenloser Stockvideos zu, die unsere Online-Funktionen zur 4K-Videobearbeitung ergänzen. Unsere Plattform ist eine 4K-Videobearbeitungssoftware für jedermann und stellt sicher, dass Ihre Projekte durch qualitativ hochwertiges Filmmaterial hervorstechen, sodass professionelle Bearbeitung für alle Benutzer zugänglich ist.',
    share: 'Aktie',
    unlisted_video: 'Nicht gelistetes Video',
    your_video_about_ready: 'Ihr Video ist bald fertig',
    hours: 'Std',
    minutes: 'Protokoll',
    seconds: 'Sekunden',
    want_free_stuff: 'Willst du ein paar kostenlose Sachen?',
    record_screen_webcam_both: 'Zeichnen Sie Ihren Bildschirm, Ihre Webcam oder beides auf',
    add_subtitle_your_video: 'Fügen Sie Untertitel zu Ihren Videos hinzu',
    create_your_team_workspace: 'Erstellen Sie Ihren Teamarbeitsbereich',
    collaborate_videos: 'Arbeiten Sie gemeinsam an Videos',
    generate_transcript: 'Erstellen Sie ein Transkript',
    singup_get_all_this_more: 'Melden Sie sich (kostenlos) an, um all das und noch mehr zu erhalten!',
    downloading: 'wird heruntergeladen',
    download: 'Herunterladen',
    reedit_video: 'Video erneut bearbeiten',
    remove_watermark: 'Wasserzeichen entfernen',
    already_have_account: 'Sie haben bereits ein Konto?',
    link_copied: 'Link kopiert',
    invitation_list: 'Einladungsliste',
    remove_invitation: 'Einladung entfernen',
    change_workspace: 'Arbeitsbereich ändern',
    you_login_manage_your_profile: 'Sie müssen sich anmelden, um Ihr Profil zu verwalten',
    you_dont_have_content_here: "Sie haben hier keinen Inhalt.",
    name: 'Name',
    status: 'Status',
    data_modified: 'Datum geändert',
    all_workspaces: 'Alle Arbeitsbereiche',
    delete_project: 'Projekt löschen',
    duplicate_project: 'Doppeltes Projekt',
    draft: 'Entwurf',
    edit: 'Bearbeiten',
    surname: 'Nachname',
    email: 'Email',
    plan: 'Planen',
    market_emails: 'Marketing-E-Mails',
    editor_notification: 'Editor-Benachrichtigungen',
    storage: 'Lagerung',
    subtitle: 'Untertitel',
    delete_account: 'Konto löschen',
    this_action_irreversibe: 'Diese Aktion ist irreversible',
    current_plan: 'DERZEITIGER PLAN',
    cancel_subscription: 'Abonnement beenden',
    payment_method: 'ZAHLUNGSARTEN',
    expires: 'Läuft ab',
    make_default: 'Machen Standard',
    delete: 'Löschen',
    add_payment_method: 'Zahlungsmethode hinzufügen',
    billing_information: 'ABRECHNUNGSDATEN',
    invoice_history: 'RECHNUNGSVERLAUF',
    payment: 'Zahlung',
    preferences: 'Präferenzen',
    save_up_to: 'Sparen Sie bis zu',
    your_plan: 'Dein Plan',
    inactive: 'Inaktiv',
    contact_sales: 'Kontaktieren Sie den Vertrieb',
    need_additional_features: 'Benötigen Sie zusätzliche Funktionen? Fragen Sie uns nach unserem Enterprise-Plan',
    your_online: 'Dein Online',
    ai_video_editor: 'KI-Video-Editor',
    integrations: 'Integrationen',
    screen_and_cam_recorder: 'Bildschirm- und Kamerarekorder',
    subtitle_translation: 'Untertitelübersetzung',
    custom_privacy_and_security: 'Benutzerdefinierte Datenschutz- und Sicherheitseinstellungen',
    video_player: 'Videoplayer',
    video_compressor_basic: 'Basis-Videokompressor',
    subtitles: 'Untertitel',
    workflow_tools: 'Workflow-Tools',
    share_and_embed: 'Teilen & Einbetten',
    video_export_length: "Videolänge exportieren",
    upload_file_size: "Datei-Upload-Größe",
    upload_file_size_tip: "Maximale Dateigröße, die Sie für den Upload in ein Projekt hochladen können",
    upload_file_size_unlimited: "Datei-Upload-Größe – unbegrenzt",
    the_basics: "Die Grundlagen",
    no_watermark: "Kein Wasserzeichen",
    pricing_compare_header: "Pakete vergleichen",
    pricing_all_plans_description:
        "Alle Pläne beinhalten alle Video-Bearbeitungsfunktionen, automatische Untertitel, unbegrenzte Projekte und unbegrenzte Exporte",
    pricing_apply_coupon: "Gutschein anwenden",
    pricing_faq_header: "Häufig gestellte Fragen",
    support: 'Support',
    tip_no_watermark: "Ob das Video ein Wasserzeichen hat oder nicht",
    custom_templates:'Benutzerdefinierte Vorlagen',
    ai_video_editor: 'Video Editor mit KI',
    one_click_post_production: 'Postproduktion mit einem Klick',
    while_pet_your_cat: 'Während Sie Ihre Katze streicheln / Ihren Kaffee schlürfen',
    export_quality_1080p: "Exportqualität – 1080p",
    video_export_length_tip: "Maximale Videolänge, die Sie exportieren können",
    video_export_length_free: "10 Min.",
    video_export_length_basic: "25 Min.",
    video_export_length_pro: "120 Min.",
    video_export_length_business: "120 Min.",
    private_workspaces: 'Private Arbeitsbereiche',
    audio_noise_removal: 'Entfernung von Audiorauschen',
    video_compressor_pro: 'Pro-Videokompressor',
    corporate_add_ons: 'Unternehmens-Add-Ons',
    video_compressor_max: 'Maximaler Videokompressor',
    video_compressor_premium: 'Premium-Videokompressor',
    convert_video_basic: 'Basis-Videokonverter',
    convert_video_pro: 'Pro-Videokonverter',
    convert_video_max: 'Maximaler Videokonverter',
    convert_video_premium: 'Premium-Videokonverter',
    video_compressor: 'Videokompressor',
    one_click_post_production: 'Postproduktion mit einem Klick',
    while_pet_your_cat: 'Während Sie Ihre Katze streicheln / Ihren Kaffee schlürfen',
    try_for_free: 'Kostenlos testen',
    your_online_ai_video_editor: 'Dein Online-KI-Video-Editor',
    discover_kedy: "Entdecke die KI-Tools von Kedy.AI!",
    create_video_summaries: "Erstelle KI-generierte Videozusammenfassungen",
    video_summary_description: "Kedy.AI erstellt aus langen Videos Schlüsselsektionen mit Titeln, Beschreibungen und einfachen Downloads – schnell und mühelos.",
    ai_video_dubbing: "Sprachbarrieren überwinden mit KI-Voice-Dubbing",
    ai_video_dubbing_description: "Das Dubbing-Tool von Kedy.AI lässt dich jede Sprache sprechen – mit deiner eigenen Stimme. Einfach Video hochladen, der Rest läuft automatisch.",
    ai_shorts_reels_generator: "KI Shorts/Reels Generator",
    select_options_to_create_shorts: "Wähle Optionen zur Erstellung von KI-gesteuerten Shorts/Reels-Videos.",
    select_ai_shorts_options: "KI Shorts Optionen auswählen",
    summarize_your_content_in: "Fasse deinen Inhalt zusammen in . . .",
    set_silence_threshold: "Stille-Schwelle festlegen (in Sekunden):",
    more_chapters: "Mehr Kapitel",
    less_chapters: "Weniger Kapitel",
    set_min_clip_duration: "Minimale Clip-Dauer festlegen (in Sekunden):",
    set_num_of_chapters: "Anzahl der Kapitel festlegen:",
    viral_clips: "Erstelle virale Clips mit dem KI-Viral-Generator für Social Media",
    viral_clips_description: "Verwandle jedes Video in auffällige virale Clips mit Kedy.AI – intelligente Gesichtsfokussierung, hervorgehobene Untertitel und teilbare Inhalte für Social Media-Erfolg!",
    kedy_ai_editor: "Kedy.AIs Editor bietet alles, was du brauchst",
    kedy_offers_essential_video_editor_tools: "Kedy.AI bietet alle wichtigen Tools eines Videoeditors",
    create_project: "Projekt erstellen",
    other_ai_tools: "Weitere moderne KI-Tools",
    ai_generated_subtitles: "Automatisch generierte KI-Untertitel",
    ai_translation: "KI-Übersetzung",
    ai_text_to_speech: "Text-zu-Sprache",
    ai_generated_images: "KI-generierte Bilder",
    finish_post_production: "Beende deine Postproduktion mit nur wenigen Klicks!",
    try_now: "Jetzt ausprobieren"
};